import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from 'utils/constants/authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

export const initializeMsal = async (): Promise<void> => {
  try {
    await msalInstance.initialize();
  } catch (error) {
    console.error('Failed to initialize MSAL:', error);
    throw error;
  }
};

export default msalInstance;
